export const SET_IS_FETCHING_DATA = "SET_FETCHING_DATA";
export const SET_ERROR = "SET_FETCHING_ERROR";
export const SET_AGENCIES = "SET_AGENCIES";
export const SET_CURRENT_AGENCY = "SET_CURRENT_AGENCY";
export const SET_AGENCY_STATUS_FILTER = "SET_AGENCY_STATUS_FILTER";

// external mutation types
export const NS_SET_ERROR = "agencies/SET_FETCHING_ERROR";
